/*
 * This file is part of the Norges Musikkhøyskole Nettsted 2020 application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const sort = (a, b) => {
  const nameA = a.name.toUpperCase();
  const nameB = b.name.toUpperCase();
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  return 0;
};

/**
 * This is the OptionsType component.
 *
 * @author Anders Stalheim Øfsdahl <anders@apt.no>
 *
 * @return {JSX}
 */
function OptionsType({ active, items, onClick }) {
  const sorted = items.sort(sort);

  // console.log({ active });

  return sorted.map((item) => (
    <button
      className={classNames('chip', {
        'chip-checked': active && active.includes(item.value),
      })}
      key={item.value}
      onClick={() => {
        onClick(item.value);
      }}
    >
      {item.name}
    </button>
  ));
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
OptionsType.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape).isRequired,
  onClick: PropTypes.func.isRequired,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
OptionsType.defaultProps = {};

export default OptionsType;
